import Axios from 'axios';
import header from './auth/header';

const API_URL =  process.env.API_URL + '/api/v1/';

class BiayaJasa {
    index(){
        return Axios.get(API_URL + 'biayaJasaOnMitra', { headers:header() });
    }
    thismonth(){
        return Axios.get(API_URL + 'biaya-jasa-this-month', { headers:header() });
    }
}
export default new BiayaJasa();


// WEBPACK FOOTER //
// ./src/api/biayajasa.js